import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import styled from "styled-components"

import svgTwitter from "../svg/socials/twitter.svg"
// import svgResume from "../svg/socials/resume.svg";
// import svgEmail from "../svg/socials/email.svg";

const BioWrapper = styled.div`
  position: relative;
  width: ${(props) => props.theme.sizes.bioWidth};
  padding: 1.5em;
  font-size: 14px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ecece2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  @media screen and (max-width: ${(props) => props.theme.responsive.large}) {
    margin: 2em 0;
    width: 100%;
  }
  @media screen and (max-width: ${(props) => props.theme.responsive.small}) {
    padding: 1.3em 1em;
  }

  .avatar {
    border-radius: 50%;
  }
`
const BioHeader = styled.div`
  display: flex;
  align-items: center;
`
const BioName = styled.div`
  margin-left: 10px;
  a {
    font-weight: 600;
    letter-spacing: 1px;
    font-size: 1.3em;
    color: dimgray;
  }
`
const BioMain = styled.div`
  margin-top: 1em;
`
const BioText = styled.p`
  color: dimgray;
`
const BioLinks = styled.div`
  margin-top: 1.5em;
  display: flex;
  color: dimgray;
  text-align: center;
  max-width: 244px;
  .bio-link {
    width: 33.3%;
    display: block;
    font-weight: 600;
    font-size: 0.9em;
    line-height: 30px;
    color: ${(props) => props.theme.colors.gray};
    letter-spacing: 0.5px;
    &:hover {
      color: ${(props) => props.theme.colors.highlight};
    }
  }
  img {
    display: block;
    margin: 0 auto;
    width: 40px;
    height: 33px;
  }
`

const Bio = () => {
  return (
    <StaticQuery
      query={bioQuery}
      render={(data) => {
        const { author, social } = data.site.siteMetadata
        return (
          <BioWrapper>
            <BioHeader>
              <Image
                fixed={data.avatar.childImageSharp.fixed}
                alt={author}
                className="avatar"
              />
              <BioName>
                <a href={`https://twitter.com/${social.twitter}`}>{author}</a>
              </BioName>
            </BioHeader>
            <BioMain>
              <BioText>
                零細CEO兼プログラマー投資家ピアニスト。老後は曾孫達の前でグランドピアノをエレガントに弾きこなしドヤって逝くのを夢みるフルータリアンな人。とっても冷え性。Next.js+microCMS,
                React Native+Expo, Firebase, TailwindCSS #XRP
              </BioText>
              <BioLinks>
                {/* <a
                  className="bio-link bio-link--email"
                  href="mailto:test@gmail.com"
                >
                <img src={svgEmail} alt="" />
                <div>E-mail</div>
              </a> */}
                <a className="bio-link" href="https://twitter.com/ru88s">
                  <img src={svgTwitter} alt="Twitter" />
                  <div>Twitter</div>
                </a>
              </BioLinks>
            </BioMain>
          </BioWrapper>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
      childImageSharp {
        fixed(width: 70, height: 70) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`

export default Bio
